import cn from 'classnames';

import ArrowForward from 'assets/icons/arrow-forward.svg';

import InlineIconText from '../InlineIconText';
import Link, { LinkProps } from '../Link';

import styles from './ArrowLink.module.scss';

export type ArrowLinkProps = Omit<LinkProps, 'children'> & {
  variant: 'large' | 'medium' | 'small';
  theme?: 'on-light' | 'on-dark';
  field?: string;
};

const ArrowLink = (props: ArrowLinkProps): JSX.Element => {
  const { variant, theme = 'on-light', href, className, field, ...other } = props;

  return (
    <Link
      className={cn(styles.main, styles[variant], styles[theme], className)}
      href={href}
      {...other}
    >
      <InlineIconText field={field || ''} icon={<ArrowForward className={styles['arrow']} />} />
    </Link>
  );
};

export default ArrowLink;
